import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { chartColors, getSizeColor, getUserRoleColor } from '../../../config/constantsColor';

const PieChart = ({ label, data, statusChoice, firstPeriodData, secondPeriodData, sizeData, userRoleList}) => {

    // Transform data for Counterfeit label and Cross Selling label
    const getChartData = () => {
        if (label === "Counterfeit" || label === "Cross Selling") {
            const totalCount = data?.size_counts?.reduce((sum, item) => sum + item.count, 0);

            if (totalCount === 0) {
                return [{
                    name: 'No Data',
                    y: 100,  // Using 100 to make a full circle
                    color: '#F5F5F5'  // Light gray for empty state
                }];
            }

            return data?.size_counts.map(item => ({
                name: item.size + '"',
                y: item.percentage,  // Using percentage instead of count
                color: getSizeColor(item.size, sizeData)
                // color: chartColors[item.size + '"']
            }));
        } else if (label === "Scan By") {
            const getCount = (item) =>
                item.total_count || (item.genuine_count + item.counterfeit_count) || 0;

            const totalCount = data?.user_roles?.reduce(
                (sum, item) => sum + getCount(item),
                0
            );
            if (totalCount === 0) {
                return [{
                    name: 'No Data',
                    y: 100,
                    color: '#F5F5F5'
                }];
            }

            return data?.user_roles?.map(item => ({
                name: item.user_role,
                y: item.percentage || getCount(item),
                color: getUserRoleColor(item.user_role, userRoleList),
            }));
        } else if (label === "Top 5 Counterfeit Products" || label === "Top 5 Cross Selling Products") {
            return data?.top_sizes?.map(item => ({
                name: item.size,
                y: item.percentage,
                color: getSizeColor(item.size, sizeData)
                // color: chartColors[item.size + '"'] 
            }));
        } else if (label === "Product Over Product") {
            const totalCount = data?.size_summary?.reduce((sum, item) => sum + item.total_count, 0);
            if (totalCount === 0) {
                return [{
                    name: 'No Data',
                    y: 100,
                    color: '#F5F5F5'
                }];
            }

            return data?.size_summary?.map(item => ({
                name: item.size,
                y: item.percentage,
                color: getSizeColor(item.size, sizeData)
                // color: chartColors[item.size + '"']
            }));
        } else if (label === "Period Over Period") {
            const firstPeriodSummary = firstPeriodData?.size_summary || [];
            const secondPeriodSummary = secondPeriodData?.size_summary || [];

            // Combine data from both periods
            const combinedData = [
                ...firstPeriodSummary.map(item => ({
                    name: `Previous Period ${item.size}"`,
                    y: item.count,
                    percentage: item.percentage,
                    color: '#B41C7A' // darker pink for previous period
                    
                })),
                ...secondPeriodSummary.map(item => ({
                    name: `Current Period ${item.size}"`,
                    y: item.count,
                    percentage: item.percentage,
                    color: '#F385B7' // lighter pink for current period
                })),
                
            ];

            return combinedData.length > 0 ? combinedData : [{
                name: 'No Data',
                y: 100,
                color: '#F5F5F5'
            }];
        }
    };

    const getCenterData = () => {
        if (label === "Counterfeit" || label === "Cross Selling") {
            return data?.total;
        } else if (label === "Scan By") {
            return data?.overall_total_count;
        } else if (label === "Top 5 Counterfeit Products" || label === "Top 5 Cross Selling Products") {
            return data?.overall_total_count;
        } else if (label === "Product Over Product") {
            return data?.total_count;
        } else if (label === "Period Over Period") {
            return (firstPeriodData?.total_count || 0) + (secondPeriodData?.total_count || 0);
        }
        else {
            return '1660';
        }
    }

    const options = {
        chart: {
            type: 'pie',
            height: 300,
            width: 300,
            backgroundColor: 'transparent',
            align: "center",
            verticalAlign: "middle",
        },
        title: {
            text: getCenterData(),
            align: "center",
            verticalAlign: "middle",
            y: label === 'Scan By' || label === "Top 5 Counterfeit Products" || label === "Top 5 Cross Selling Products" ? 20 : 10,
            x: 0,
            style: {
                fontSize: "29px",
                fontWeight: "bold",
                color: "#001323",
            },
        },
        // Conditionally render the subtitle based on the label prop
        ...(label !== 'Scan By' && label !== "Top 5 Counterfeit Products" && label !== "Top 5 Cross Selling Products" && {
            subtitle: {
                text: label === "Product Over Product" || label === "Period Over Period" ? statusChoice : label, // for Product over product chart label is product over product but center need to show statusChoice
                align: 'center',
                verticalAlign: 'middle',
                y: 25,  // Positioned below the title
                x: 0,
                style: {
                    fontSize: "16px",
                    color: "#001323",
                },
            }
        }),
        plotOptions: {
            pie: {
                innerSize: '70%',
                size: '100%',
                dataLabels: {
                    enabled: false,
                },
                startAngle: 180,
            },
        },
        tooltip: {
            useHTML: true,
            headerFormat: '',
            pointFormat: '<span style="font-size: 18px">{point.name}</span><br><span style="font-size: 14px"><b>{point.percentage:.0f}%</b></span>'
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [{
            name: 'Scans',
            data: getChartData(),
        }]
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default PieChart;
